import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  reactive,
  ref,
  watch,
} from 'vue'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { Store } from 'pinia'
import { FloatingPanel, Popup } from 'vant'
import { RouterView, useRoute } from 'vue-router'
import styles from './styles.module.scss'
// import InformationMobile from '../informationComps/information/informationMobile'
// import InformationMobileLegend from '../informationComps/information/informationMobile/legend'
import InformationMobileV2 from '../informationComps/informationV2/informationMobile'
import InformationMobileLegendV2 from '../informationComps/informationV2/informationMobile/legend'
import ChooseCity from '../summary/chooseCity'
import PhoneCall from '../actionButton/phoneCall'
import PositionIcon from '../actionButton/positionRender/positionIcon'
import { ChargeMapContext } from '../chargerMap/index.model'
import SharePoster from '../actionButton/sharePoster'
import BtnGroup from '../btnGroup'
import Tracker from '@nio-fe/nio-tracker-web'
import CountyLayoutPositionIcon from '../countyLayout/position/countyLayoutPositionIcon'
// import CountyLayoutLegend from '../countyLayout/countyLayoutLegend/countyLayoutLegend'
import BottomButton from '../card/BottomButton.vue'
import NumberAnimationBg from '../informationComps/informationV2/NumberAnimationBg'

export default defineComponent({
  name: 'popup-drag-view',
  components: {
    'van-floating-panel': FloatingPanel,
    'bottom-button': BottomButton,
  },
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  emits: [],
  setup: (props) => {
    const brand = (process.config as { [key: string]: any }).brand
    const mapInstance = computed(() => props.mapInstance)
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const route = useRoute()
    let routeNameTemp = route.name
    let stopZoomDrag = false // 是否阻止缩放拖拽改变popup level
    const state = reactive({
      isShow: false, // Popup显示隐藏,
    })
    const anchors = [
      Math.round(0.25 * window.innerHeight),
      Math.round(0.45 * window.innerHeight),
      Math.round(0.8 * window.innerHeight + 60), // 60 解决兼容性问题，
    ]
    const height = ref(anchors[1])
    let initMinZoom = 0

    const showSummary = computed(() => props.componentStore.showSummary) // 是否展示概要
    const showRouteArea = ref(false) // 是否展示路由区域
    const contentDraggable = ref(true) // 是否展示路由区域
    const SHOW_SHARE_POSTER_ROUTE_NAME = ['resource', 'pin', 'data_summary'] // 可以展示数据海报分享按钮的路由
    const SHOW_POSITION_ICON_ROUTE_NAME = ['resource', 'pin', 'data_summary'] // 可以展示定位按钮的路由
    const SHOW_COUNTY_LAYOUT_POSITION_ICON_ROUTE_NAME = ['countyLayout'] // 可以展示定位按钮的路由
    const SHOW_PHONE_CALL_ROUTE_NAME = ['resource', 'pin', 'data_summary'] // 可以展示电话按钮的路由

    const onChangeHeightLevel = (level: number) => {
      let popupDragLevel = 1
      if (!showSummary.value) {
        // 回到首页默认为1
        popupDragLevel = level
      }
      height.value = anchors[popupDragLevel]
      props.componentStore.$patch({
        popupDragLevel,
      })
    }
    // 向外暴露修改高度的方法
    props.componentStore.bus.on('onChangeHeightLevel', onChangeHeightLevel)

    props.componentStore.bus.on('openPopup', () => {
      state.isShow = true
    })
    const closePopup = () => {
      state.isShow = false
    }
    props.componentStore.bus.on('closePopup', closePopup)

    /**
     * 高度改变
     * @param cur 当前高度
     */
    const handleHeightChange = (cur: { height: number }) => {
      props.componentStore.$patch({
        popupDragLevel: anchors.indexOf(cur.height),
      })
    }

    const handleLocation = () => {
      console.log('====================================')
      console.log('handleLocation')
      console.log('====================================')
      props.componentStore.bus.emit('handleLocation')
      Tracker.track('h5_page_tracker', {
        channel: window.channel,
        client: window.client,
        brand: (process.config as any).brand,
        screen_orientation: window.screen_orientation,
        view_mode: props.componentStore.viewMode,
        container: window.container,
        user_identity: window.user_identity,
        trigger: 'click',
        element: '定位按钮',
        page_source: window.page_source,
      })
    }

    const onZoomDrag = () => {
      if (stopZoomDrag) return
      if (routeNameTemp == route.name) {
        onChangeHeightLevel(0)
      } else {
        routeNameTemp = route.name
      }
      if (showSummary.value && mapInstance.value?.getZoom() !== initMinZoom) {
        // 数据信息存在且不是点击回到首页 数据信息卡片消失 进入地图模式
        props.componentStore.bus.emit('hideSummary')
        onChangeHeightLevel(0)
      }
    }

    const onMapClick = () => {
      if (showSummary.value) {
        props.componentStore.bus.emit('hideSummary')
        onChangeHeightLevel(0)
      }
    }

    const preventZoomDragAction = (timer = 1000) => {
      // 因为flyTo会触发zoomend事件，而且获取不到flyTo结束的过程，所以这里做一个延迟处理
      stopZoomDrag = true
      setTimeout(() => {
        stopZoomDrag = false
      }, timer)
    }
    props.componentStore.bus.on('preventZoomDragAction', preventZoomDragAction)

    onUnmounted(() => {
      props.componentStore.bus.off('onChangeHeightLevel')
      props.componentStore.bus.off('openPopup')
      props.componentStore.bus.off('closePopup')
      props.componentStore.bus.off('preventZoomDragAction')
      props.componentStore.bus.off('onChangeContentDraggable')
    })

    const onChangeContentDraggable = (flag: boolean) => {
      contentDraggable.value = flag
    }

    let bar: Element | null = null
    let mouseDownClientY = 0
    let mouseMoveClientY = 0
    const mouseMove = (e: any) => {
      mouseMoveClientY = e.clientY
      if (mouseMoveClientY - mouseDownClientY > 1) {
        const level = props.componentStore.popupDragLevel
        if (level > 0) {
          height.value = anchors[level - 1]
          props.componentStore.$patch({
            popupDragLevel: level - 1,
          })
        }
        bar?.removeEventListener('mousemove', mouseMove)
        mouseDownClientY = 0
        mouseMoveClientY = 0
      } else if (mouseMoveClientY - mouseDownClientY < -1) {
        const level = props.componentStore.popupDragLevel
        if (level < 2) {
          height.value = anchors[level + 1]
          props.componentStore.$patch({
            popupDragLevel: level + 1,
          })
        }
        bar?.removeEventListener('mousemove', mouseMove)
        mouseDownClientY = 0
        mouseMoveClientY = 0
      }
    }
    const mouseDown = (e: any) => {
      mouseDownClientY = e.clientY
      bar?.addEventListener('mousemove', mouseMove)
    }

    const touchEmulator = () => {
      const supportTouch = 'ontouchstart' in window
      if (!supportTouch) {
        nextTick(() => {
          bar = document.querySelector('.van-floating-panel__header')
          bar?.addEventListener('mousedown', mouseDown)
        })
      }
    }

    onMounted(() => {
      props.componentStore.bus.on('onChangeContentDraggable', onChangeContentDraggable)
    })
    // ------------暴露出去的方法--------------

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', onZoomDrag, false)
      mapInstance.value?.addEventListener('dragend', onZoomDrag, false)
      mapInstance.value?.addEventListener('click', onMapClick, false) // 首页点击地图
    }

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = () => {
      initEventListener()
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
          initMinZoom = mapInstance.value?.getZoom()
        }
      },
      {
        immediate: true,
      }
    )

    watch(
      () => [showSummary.value, showRouteArea.value],
      () => {
        bar?.removeEventListener('mousedown', mouseDown)
        bar?.removeEventListener('mousemove', mouseMove)
        if (showSummary.value || showRouteArea.value) {
          touchEmulator()
        }
      }
    )

    watch(
      () => route.name,
      () => {
        routeNameTemp = route.name
        height.value = anchors[1]
        showRouteArea.value = route.name !== 'home'
        if (showSummary.value || showRouteArea.value) {
          onChangeHeightLevel(1)
        } else {
          onChangeHeightLevel(0)
        }
      },
      {
        immediate: true,
      }
    )

    return () => (
      <>
        {/* 高卡位蒙层 */}
        {props.componentStore.popupDragLevel === 2 && (
          <div class={[styles.mask, styles.maskBlack]}></div>
        )}
        {showSummary.value || showRouteArea.value ? (
          <>
            <van-floating-panel
              v-model:height={height.value}
              anchors={anchors}
              content-draggable={contentDraggable.value}
              onHeightChange={handleHeightChange}
            >
              <div>
                {
                  showSummary.value && <InformationMobileV2></InformationMobileV2>
                  //   (brand === 'alps' || brand === 'fy' ? (
                  //     <InformationMobileV2></InformationMobileV2>
                  //   ) : (
                  //     <InformationMobile></InformationMobile>
                  // ))
                }
                {showRouteArea.value && <RouterView></RouterView>}
                {props.componentStore.popupDragLevel < 2 && (
                  <div class={styles.topFixContent}>
                    {showSummary.value ? (
                      <InformationMobileLegendV2></InformationMobileLegendV2>
                    ) : (
                      // brand === 'alps' || brand === 'fy' ? (
                      //   <InformationMobileLegendV2></InformationMobileLegendV2>
                      // ) : (
                      //   <InformationMobileLegend></InformationMobileLegend>
                      // )
                      // 其他模式下显示图例
                      <div>
                        {/* {props.componentStore.viewMode === MapViewMode.CountyLayout && (
                          <CountyLayoutLegend></CountyLayoutLegend>
                        )} */}
                      </div>
                    )}
                    {/*    --- 首页 ---   需要展示的看板右上角的icon */}
                    {showSummary.value && (
                      <div class={styles.rightContent}>
                        {componentsConfig.common?.show && componentsConfig.share?.show && (
                          <SharePoster></SharePoster>
                        )}
                        {componentsConfig.common?.show && componentsConfig.location?.show && (
                          <PositionIcon onHandleLocation={handleLocation}></PositionIcon>
                        )}
                        {componentsConfig.common?.show && componentsConfig.hotline?.show && (
                          <PhoneCall />
                        )}
                      </div>
                    )}
                    {/*    --- 各路由看板 ---   需要展示的看板右上角的icon */}
                    {showRouteArea.value &&
                      SHOW_SHARE_POSTER_ROUTE_NAME.includes(route.name as string) && (
                        <div class={styles.rightContent}>
                          {componentsConfig.common?.show && componentsConfig.share?.show && (
                            <SharePoster></SharePoster>
                          )}
                        </div>
                      )}
                    {showRouteArea.value &&
                      SHOW_POSITION_ICON_ROUTE_NAME.includes(route.name as string) && (
                        <div class={styles.rightContent}>
                          {componentsConfig.common?.show && componentsConfig.location?.show && (
                            <PositionIcon onHandleLocation={handleLocation}></PositionIcon>
                          )}
                        </div>
                      )}
                    {showRouteArea.value &&
                      SHOW_COUNTY_LAYOUT_POSITION_ICON_ROUTE_NAME.includes(
                        route.name as string
                      ) && (
                        <div class={styles.rightContent}>
                          <CountyLayoutPositionIcon></CountyLayoutPositionIcon>
                        </div>
                      )}
                    {showRouteArea.value &&
                      SHOW_PHONE_CALL_ROUTE_NAME.includes(route.name as string) && (
                        <div class={styles.rightContent}>
                          {componentsConfig.common?.show && componentsConfig.hotline?.show && (
                            <PhoneCall />
                          )}
                        </div>
                      )}
                  </div>
                )}
              </div>
            </van-floating-panel>
            {showSummary.value && <BtnGroup></BtnGroup>}
            <bottom-button></bottom-button>
            <NumberAnimationBg />
          </>
        ) : null}
        <Popup
          show={state.isShow}
          onClickOverlay={closePopup}
          position="bottom"
          class={styles.popupView}
        >
          <div class={styles.content}>
            <div class={styles.closeIcon}>
              <ns-icon
                name={(process.config as any).icon.close_big_outline}
                onClick={closePopup}
                size="27"
                color="#696D7F"
              />
            </div>
            {state.isShow && <ChooseCity></ChooseCity>}
          </div>
        </Popup>
      </>
    )
  },
})
